import { useSelector } from 'react-redux';
import { Row, Col, Card } from 'antd';

import { selectors } from '@/redux/tour/cruise/view/model';

import PhotoGallery from '@/components/PhotoGallery';
import ViewWidgetCategories from '@/components/ViewWidgetCategories';
import GeneralData from './GeneralData';
import ViewIncusionsExclusions from './ViewInclusionsExclusions';

const TourInfo = ({
    myService,
}) => {
    const generalData = useSelector(selectors.generalInfo);

    return (
        <Row gutter={30}>
            <Col lg={14} xs={24}>
                <Card bordered={false} className="left-col">
                    <GeneralData
                        data={generalData}
                        myService={myService}
                    />

                    <ViewWidgetCategories data={generalData.widget_categories} />

                    <ViewIncusionsExclusions data={generalData} />
                </Card>
            </Col>

            <Col lg={10} xs={24}>
                <Card bordered={false} className="right-col">
                    <PhotoGallery data={generalData.images} />
                </Card>
            </Col>
        </Row>
    );
};

export default TourInfo;
